import MenuSidebar from './component'

export default MenuSidebar
